import { translateDynamicKey } from '@/types/translation';
import { AppRoutes } from '@/utils';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import settings from '../../settings.json';
import { NavigationSettings } from '../types/base';
import { Breadcrumb } from '../types/breadcrumb';

const getRouteLabel = (route: AppRoutes) => {
  const keyIndex = Object.values(AppRoutes).indexOf(route);
  const id = Object.keys(AppRoutes)[keyIndex];
  return (settings.navigation as NavigationSettings).entries[id]?.label;
};

const useBreadcrumbs = () => {
  const { t } = useTranslation();

  const getBreadcrumb = useCallback(
    (route: AppRoutes, labelId?: string): Breadcrumb => {
      const id = labelId ?? getRouteLabel(route);
      return {
        label: id ? translateDynamicKey(t, id) : translateDynamicKey(t, 'n/a'),
        link: route,
      };
    },
    [t],
  );
  return { getBreadcrumb };
};

export default useBreadcrumbs;
